import {MainContentLoader} from '@udemy/react-reveal-components';

import styles from './topic-page-loader.module.less';

export const TopicPageLoader = () => {
    return (
        <div className={styles['loader-container']} data-purpose="topic-page-loader">
            <MainContentLoader />
        </div>
    );
};
